import React from 'react';
import PropTypes from 'prop-types';
import { Headline } from './Headline';

export function SplashAppTitle({ children, tag, size, ...props }) {
    return (
        <Headline tag={tag} size={size} weight="body" {...props}>
            {children}
        </Headline>
    );
}

SplashAppTitle.propTypes = {
    children: PropTypes.node.isRequired,
    size: PropTypes.string,
    tag: PropTypes.string,
};

SplashAppTitle.defaultProps = {
    size: 'large',
    tag: 'h1',
};
